import http from '@/common/http';

export const Login = async (params) => {

   return await http.post('/adminLogin/login', {data: params});
}
export const getNicknameLogin = async (params) => {

   return await http.post('/adminLogin/getNicknameLogin', {data: params});
}


export const Register = async (params) => {

   return await http.post('/wechat/permission/PhoneRegister', {data: params});
}

export const phoneUpdatePsw = async (params) => {

   return await http.post('/wechat/permission/phoneUpdatePsw', {data: params});
}



export const SendSms = async (phone) => {

   return await http.get('/wechat/permission/SendSms/' + phone);
}

